import CheckboxViews from "./CheckboxViews";
import InputViews from "./InputViews";
import MatrixRadioViews from "./MatrixRadioViews";
import MatrixScaleViews from "./MatrixScaleViews";
import ParagraphViews from "./ParagraphViews";
import UploadViews from "./UploadViews";
import NpsViews from "./NpsViews";
import RadioViews from "./RadioViews";
import SortViews from "./SortViews";
import { useSelector } from "react-redux";
import { Element } from "react-scroll";

const compRender = (item = {}, previewType, previewCheck) => {
  if (item.type == "4") return null;
  let isHide = item.jumpShow === false || item.relateShow === false;
  // previewType  存在即预览模式 1 普通预览模式
  // previewCheck true 验证逻辑模式
  // 非逻辑预览模式，直接隐藏
  if (previewCheck.toString() != "true" && isHide) return null;
  item.previewDisabled = previewType && previewCheck == "true" && isHide;
  let Comp;
  switch (item.type.toString()) {
    case "1":
      Comp = <RadioViews info={item} />;
      break;
    case "2":
      Comp = <CheckboxViews info={item} />;
      break;
    case "3":
      Comp = <InputViews info={item} />;
      break;
    case "5":
      Comp = <ParagraphViews info={item}></ParagraphViews>;
      break;
    case "6":
      Comp = <MatrixRadioViews info={item} />;
      break;
    case "7":
      Comp = <MatrixScaleViews info={item} />;
      break;
    case "8":
      Comp = <NpsViews info={item} />;
      break;
    case "9":
      Comp = <SortViews info={item} />;
      break;
    case "10":
      Comp = <UploadViews info={item} />;
      break;
    default:
      Comp = null;
      break;
  }
  return (
    <Element
      name={`question-${item.position}`}
      key={item.position}
      className={`question-item question-${item.type} ${item.errorMsg ? "error" : ""} ${
        item.previewDisabled ? "preview-disabled" : ""
      }`}
    >
      {Comp}
      {item.errorMsg && (
        <div className="error-msg">{typeof item.errorMsg == "string" ? item.errorMsg : item.errorMsg.msg}</div>
      )}
    </Element>
  );
};

const Questions = (props) => {
  const { list = [] } = props;
  const { currentPage, previewType, previewCheck } = useSelector((state) => state.app);
  return (
    <div className="questions-container">
      {list.map((item) => {
        if (currentPage != item.pageNum) return null;
        else return compRender(item, previewType, previewCheck);
      })}
    </div>
  );
};

export default Questions;
